/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Errors_Anunexpectederroroccur3Inputs */

const en_errors_anunexpectederroroccur3 = /** @type {(inputs: Errors_Anunexpectederroroccur3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An unexpected error occurred`)
};

/**
* | output |
* | --- |
* | "An unexpected error occurred" |
*
* @param {Errors_Anunexpectederroroccur3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const errors_anunexpectederroroccur3 = /** @type {((inputs?: Errors_Anunexpectederroroccur3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Errors_Anunexpectederroroccur3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_errors_anunexpectederroroccur3(inputs)
});
export { errors_anunexpectederroroccur3 as "errors_anUnexpectedErrorOccur" }